import { createContext, useContext } from 'react'
import { CabinetFullInfo } from './cabinet-info.types';

export interface ICabinetInfoContext {
  cabinetInfo: CabinetFullInfo;
}

export const CabinetInfoContext = createContext<ICabinetInfoContext | null>(null);
